import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateOrgStatusUrl } from "../../../../../config";
import api from "../../../../../api";
import { Status } from "../../../../../common/constants";
import { RootState } from "../../../../../store";
import { IInitialSliceState } from "../../../../../common/types/commonTypes";

const initialState: IInitialSliceState = {
  status: null,
  error: null,
  msg: null,
};

interface IUpdateOrgStatusResponse {
  message: string;
}

interface IUpdateOrgStatusPayload {
  displayName: string,
  isEnabled: boolean
}

export const updateOrgStatus = createAsyncThunk(
  "updateOrgStatus",
  async (payload: IUpdateOrgStatusPayload, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        updateOrgStatusUrl + `?displayName=${payload.displayName}&isEnabled=${+payload.isEnabled}`
      );
      const updateOrgStatusResponse: IUpdateOrgStatusResponse = response.data;
      return updateOrgStatusResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const updateOrgStatusSlice = createSlice({
  name: "editOrgAdmin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateOrgStatus.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(updateOrgStatus.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(updateOrgStatus.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Error occurred while updating";
        state.status = Status.FAILED;
      });
  },
});

export const selector = (state: RootState) => state.updateOrgStatus;

export const reducer = updateOrgStatusSlice.reducer;
